import { Component, Input, Output } from 'angular-ts-decorators';
import { CustomizerFilter, FilterOption } from '../../../models';
import { IHeroCustomizerV3FilterComponent } from '../../models/hero-customizer-v3.filter.component';

import template from './hero-customizer-v3-filter-radio.component.html';

@Component({
  selector: 'heroCustomizerV3FilterRadio',
  template,
})
export class HeroCustomizerV3FilterRadioComponent implements IHeroCustomizerV3FilterComponent {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public filter?: CustomizerFilter;

  @Output() public onFilterChange?: ({ filter: CustomizerFilter }) => void;

  public onOptionClicked(option: FilterOption) {
    if (option.checked) {
      return;
    }

    this.filter.options.forEach((x: FilterOption) => { x.checked = false; });
    option.checked = true;
    if (this.onFilterChange) {
      this.onFilterChange({ filter: this.filter });
    }
  }
}
